import type { AllRouteEndpoints } from "../routeTypes";
export const engagementPredictionsCacheKeys: AllRouteEndpoints[] = ["/engagement/prediction_data(/:prediction_id)"];
